import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface gamePromptState {
  gamePrompt: string
  oldPrompts: string[]
}

const initialState: gamePromptState = {
  gamePrompt: '',
  oldPrompts: [],
}

export const gamePromptSlice = createSlice({
  name: 'gamePrompt',
  initialState,
  reducers: {
    setGamePrompt: (state, action: PayloadAction<string>) => {
      state.oldPrompts = [...state.oldPrompts, state.gamePrompt]
      state.gamePrompt = action.payload.trim()
    },
    clearGamePrompt: (state) => {
      state.gamePrompt = ''
    },
  },
})

export const { setGamePrompt, clearGamePrompt } = gamePromptSlice.actions

export default gamePromptSlice.reducer
